import * as yup from 'yup';

export const useFullnameValidation = () => {
  return {
    full_name: yup.string().trim().required('Введите фамилию, имя и отчество'),
  };
};
